import { Card, CardContent, Typography } from '@material-ui/core';
import { motion } from 'framer-motion';

// icons
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// local imports
import { AsyncButton } from 'app/components/atoms';
import { PharmacyService } from 'app/services';
import { useStateCallback } from 'app/hooks';
import { useCallback } from 'react';

// animation variants
const item = {
  hidden: { opacity: 0, x: -40 },
  show: { opacity: 1, x: 0, transition: { delay: 0.2 } }
};

const PharmacyDetailCard = ({ id, handleRefresh, isTurp, duty, code, times }) => {
  const isTurpPharmacyStatus = !isTurp;
  const [loading, setLoading] = useStateCallback(false);

  // handle update pharmacy => is_turp_pharmacy status
  const handleUpdate = useCallback(async () => {
    setLoading(true, async () => {
      const serviceFn = () => PharmacyService.updateTurpStatus(id, isTurpPharmacyStatus);
      try {
        await serviceFn();
        handleRefresh();
      } catch (err) {
        console.log('Error -> ', err);
      } finally {
        setLoading(false);
      }
    });
  }, [setLoading, id, isTurpPharmacyStatus, handleRefresh]);

  const dutyText = duty
    ? { text: 'Nöbetçi', color: 'success' }
    : { text: 'Nöbetçi Değil', color: 'danger' };

  const isTurpPharmacy = condition => (
    <>
      {!condition ? (
        <CancelIcon color="error" />
      ) : (
        <CheckCircleIcon color="action" className="text-green-600" />
      )}
    </>
  );

  // variables
  const btnColor = !isTurp ? 'secondary' : 'primary';
  const btnText = !isTurp ? 'Turp Eczanesi Yap' : 'Turp Eczanesinden çıkar';

  return (
    <>
      <Card elevation={4} className="mb-16">
        <CardContent className="flex items-start ">
          {/* Pharmacy Info -> */}
          <motion.div
            className="flex-1 flex flex-col justify-start items-start space-y-8"
            variants={item}
            initial="hidden"
            animate="show">
            <Typography>
              <span className="md:text-15 font-semibold text-gray-800 mr-6">Turp Eczanesi:</span>
              {isTurpPharmacy(isTurp)}
            </Typography>
            <Typography>
              <span className="md:text-15 font-semibold text-gray-800 mr-6">Nöbet Bilgisi:</span>
              {/* <CustomBadge content={dutyText.text} status={dutyText.color} /> */}
              <span className="text-14">{dutyText.text}</span>
            </Typography>
            <Typography>
              <span className="md:text-15 font-semibold text-gray-800 mr-6">Eczane Kodu: </span>
              <span className="text-14"> {code} </span>
            </Typography>
            <Typography>
              <span className="md:text-15 font-semibold text-gray-800 mr-6">Çalışma Saatleri:</span>
              <span className="text-14">
                {times.start_time} - {times.end_time}
              </span>
            </Typography>
          </motion.div>

          {/* Action Button */}
          <motion.div variants={item} initial="hidden" animate="show">
            <AsyncButton
              type="button"
              className=""
              color={btnColor}
              text={btnText}
              loading={loading}
              handleClick={handleUpdate}
            />
          </motion.div>
        </CardContent>
      </Card>
    </>
  );
};

export default PharmacyDetailCard;
